import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { PaymentChannelEnum } from './enums';
import { getToggle } from '../feature-toggles';
import { postRequest, postBRRequest } from '../../services/public-api.services';
import { catchError } from '../catch-error';
export var postNotification = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(idNumber, channel, idType, body) {
    var path, toggles, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (idType === void 0) {
              idType = 'CC';
            }

            if (!(idNumber && channel && idType)) {
              _context.next = 17;
              break;
            }

            _context.prev = 2;
            path = "/clients/" + idType + "-" + idNumber + "/payments/payment-methods/" + channel;
            _context.next = 6;
            return getToggle();

          case 6:
            toggles = _context.sent;

            if (toggles.corresponsalWompiEnabled({
              'idNumber': idNumber
            }) && PaymentChannelEnum.BANCOLOMBIA_CORRESPONDENT === channel) {
              path = "/clients/" + idType + "-" + idNumber + "/payments/bancolombia_collect";
            }

            _context.next = 10;
            return postRequest(path, body);

          case 10:
            response = _context.sent;
            return _context.abrupt("return", {
              status: response.status,
              data: response.data
            });

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", catchError(_context.t0));

          case 17:
            return _context.abrupt("return", catchError({
              message: 'missing query parameters'
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 14]]);
  }));

  return function postNotification(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var postBRNotification = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(idNumber, channel, idType, body) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (idType === void 0) {
              idType = 'CPF';
            }

            if (!(idNumber && channel && idType)) {
              _context2.next = 12;
              break;
            }

            _context2.prev = 2;
            _context2.next = 5;
            return postBRRequest("/clients/" + idType + "-" + idNumber + "/" + channel, body);

          case 5:
            response = _context2.sent;
            return _context2.abrupt("return", {
              status: response.status,
              data: response.data
            });

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", catchError(_context2.t0));

          case 12:
            return _context2.abrupt("return", catchError({
              message: 'missing query parameters'
            }));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 9]]);
  }));

  return function postBRNotification(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}(); //todo: should be removed

export var sendCashPaymentNotification = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(idNumber, paymentOption, paymentAmount, idType, channel) {
    var body;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (channel === void 0) {
              channel = PaymentChannelEnum.KUSHKI_RECEIPT;
            }

            if (!(idNumber && paymentOption)) {
              _context3.next = 4;
              break;
            }

            body = paymentAmount ? {
              "amountPayable": paymentOption,
              "customAmount": paymentAmount
            } : {
              "amountPayable": paymentOption
            };
            return _context3.abrupt("return", postNotification(idNumber, channel, idType, body));

          case 4:
            return _context3.abrupt("return", catchError({
              message: 'missing query parameters'
            }));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function sendCashPaymentNotification(_x9, _x10, _x11, _x12, _x13) {
    return _ref3.apply(this, arguments);
  };
}(); // todo: should rename this function after remove old one

export var postNotificationNew = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(idNumber, channel, idType, body, authorizationToken) {
    var path, toggles;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (idType === void 0) {
              idType = 'CC';
            }

            if (body === void 0) {
              body = {};
            }

            if (authorizationToken === void 0) {
              authorizationToken = '';
            }

            _context4.prev = 3;

            if (!(!idNumber || !channel)) {
              _context4.next = 6;
              break;
            }

            throw {
              message: 'missing query parameters'
            };

          case 6:
            path = '';
            _context4.next = 9;
            return getToggle();

          case 9:
            toggles = _context4.sent;

            if (!(toggles.corresponsalWompiEnabled({
              'idNumber': idNumber
            }) && PaymentChannelEnum.BANCOLOMBIA_CORRESPONDENT === channel)) {
              _context4.next = 14;
              break;
            }

            path = "/clients/" + idType + "-" + idNumber + "/payments/bancolombia_collect";
            _context4.next = 15;
            break;

          case 14:
            return _context4.abrupt("return", null);

          case 15:
            _context4.next = 17;
            return postRequest(path, body, {
              headers: {
                Authorization: authorizationToken
              }
            });

          case 17:
            return _context4.abrupt("return", _context4.sent);

          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](3);
            throw catchError(_context4.t0);

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 20]]);
  }));

  return function postNotificationNew(_x14, _x15, _x16, _x17, _x18) {
    return _ref4.apply(this, arguments);
  };
}();
export var postCashPaymentNotification = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(idNumber, paymentOption, paymentAmount, token, idType, channel) {
    var body;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (channel === void 0) {
              channel = PaymentChannelEnum.KUSHKI_RECEIPT;
            }

            if (!(!idNumber || !paymentOption)) {
              _context5.next = 3;
              break;
            }

            throw {
              message: 'missing query parameters'
            };

          case 3:
            body = paymentAmount ? {
              "amountPayable": paymentOption,
              "customAmount": paymentAmount
            } : {
              "amountPayable": paymentOption
            };
            _context5.next = 6;
            return postNotificationNew(idNumber, channel, idType, body, token);

          case 6:
            return _context5.abrupt("return", _context5.sent);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function postCashPaymentNotification(_x19, _x20, _x21, _x22, _x23, _x24) {
    return _ref5.apply(this, arguments);
  };
}();